var rtl_rtlignore_default = {
  "rtl": "VDdfP",
  "ltr": "qpY4V"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
